module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "subpage addrule_edit"
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "model": _vm.params,
      "rules": _vm.rules,
      "show-message": true,
      "label-position": "right",
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "所属栏目",
      "prop": "columnId"
    }
  }, [_c('el-cascader', {
    ref: "cascaderColumn",
    attrs: {
      "disabled": _vm.disabled,
      "size": "medium",
      "options": _vm.columnTree,
      "show-all-levels": true,
      "props": {
        value: 'id',
        label: 'name',
        children: 'dtos',
        checkStrictly: true
      },
      "value": _vm.ids,
      "clearable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.selectChange
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "标题",
      "prop": "title"
    }
  }, [_c('el-input', {
    staticClass: "inpText",
    attrs: {
      "disabled": _vm.disabled,
      "size": "medium",
      "placeholder": "请输入活动标题"
    },
    model: {
      value: (_vm.params.title),
      callback: function($$v) {
        _vm.$set(_vm.params, "title", $$v)
      },
      expression: "params.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "缩略图",
      "prop": "thumbnail"
    }
  }, [_c('imgs-upload', {
    attrs: {
      "disabled": _vm.disabled,
      "tips": "（115*70推荐）",
      "limit": "1"
    },
    on: {
      "change": _vm.fileChange
    },
    model: {
      value: (_vm.params.thumbnail),
      callback: function($$v) {
        _vm.$set(_vm.params, "thumbnail", $$v)
      },
      expression: "params.thumbnail"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "摘要",
      "prop": "summary"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "750px"
    },
    attrs: {
      "disabled": _vm.disabled,
      "type": "textarea"
    },
    model: {
      value: (_vm.params.summary),
      callback: function($$v) {
        _vm.$set(_vm.params, "summary", $$v)
      },
      expression: "params.summary"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "内容",
      "prop": "content"
    }
  }, [_c('text-editor', {
    ref: "textEditor",
    staticStyle: {
      "width": "750px"
    },
    attrs: {
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.params.content),
      callback: function($$v) {
        _vm.$set(_vm.params, "content", $$v)
      },
      expression: "params.content"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "信息状态",
      "prop": "status"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.params.status),
      callback: function($$v) {
        _vm.$set(_vm.params, "status", $$v)
      },
      expression: "params.status"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("待审核")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 3
    }
  }, [_vm._v("上线")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 4
    }
  }, [_vm._v("退回")])], 1), _vm._v(" "), (_vm.params.status == 4) ? _c('el-input', {
    staticClass: "inpText",
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "size": "medium",
      "placeholder": "请填写退回意见"
    },
    model: {
      value: (_vm.params.meassage),
      callback: function($$v) {
        _vm.$set(_vm.params, "meassage", $$v)
      },
      expression: "params.meassage"
    }
  }) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.1.0@vue-loader/lib/template-compiler?{"id":"data-v-49872700"}!./~/_vue-loader@12.1.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/cms/article/article_examine/add/src/Subpage1.vue
// module id = 1477
// module chunks = 1